import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Sub-navegação da página: abas sublinhadas.
 *
 * **Não confundir com segmented control.** O segmented (que continua
 * existindo, como está) troca a VISÃO DOS MESMOS DADOS — Kanban/Lista,
 * Cards/Tabela, 7/30/90 dias. `PageTabs` troca PÁGINA DENTRO DA PÁGINA:
 * Dashboard · Registros · Configuração.
 *
 * No celular rola na horizontal — **nunca** quebra em duas linhas, senão o
 * cabeçalho empurra o conteúdo para fora da primeira dobra.
 */
export interface PageTabsProps {
  abas: { id: string; label: string; icone?: LucideIcon }[];
  ativa: string;
  onChange: (id: string) => void;
  className?: string;
}

export function PageTabs({ abas, ativa, onChange, className }: PageTabsProps) {
  return (
    <div className={cn("border-b overflow-x-auto scrollbar-none", className)}>
      <div className="flex items-center gap-6 min-w-max">
        {abas.map(aba => {
          const Icone = aba.icone;
          const selecionada = aba.id === ativa;
          return (
            <button
              key={aba.id}
              type="button"
              onClick={() => onChange(aba.id)}
              data-testid={`tab-${aba.id}`}
              aria-current={selecionada ? "page" : undefined}
              className={cn(
                "h-9 -mb-px inline-flex items-center gap-2 whitespace-nowrap border-b-2 text-sm transition-colors",
                selecionada
                  ? "text-foreground font-semibold border-primary"
                  : "text-muted-foreground font-medium border-transparent hover:text-foreground",
              )}
            >
              {Icone && <Icone className="h-4 w-4" />}
              {aba.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
